import { GetDataSourceLogo } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { Flex, Text } from "@theorgchartdev/storybook";
import { CapitalizeFirstWord } from "@/Utils/DataLib";
import { appstr } from "@coreapp/utils/appstr";
import { kConnectorDict } from "@coreapp/constants";

export const DataSourceRecordDetails = ({ recordDetails }) => {
  if (!recordDetails?.source) {
    return;
  }

  const sourceInfo = recordDetails.source;
  const sourceDetails = sourceInfo?.details;
  let sourceType = sourceInfo.type;
  const connectorList = kConnectorDict[sourceType];
  let sourceName = sourceInfo.name;
  let sourceImage;

  if (connectorList) {
    var index = connectorList
      .map(function (item) {
        return item.command;
      })
      .indexOf(sourceName);
    sourceImage = GetDataSourceLogo(sourceName);

    var theConnector = connectorList[index];
    if (theConnector) {
      sourceName = theConnector.connector;
    }
    if (["main", "append"].includes(sourceType)) sourceType = CapitalizeFirstWord(sourceType);

    if (sourceType.length > 0) sourceName = sourceType + " - " + sourceName;
  }

  let sourceTip = undefined;
  if (sourceDetails) {
    if (typeof sourceDetails === "string") {
      if (sourceDetails.length > 0) sourceTip = sourceDetails;
    } else if (typeof sourceDetails === "object") {
      if (sourceDetails["name"]) sourceTip = sourceDetails["name"];
    }
  }

  const fieldLabelProps = {
    size: "xsmall",
    colorModifier: "grey",
    modifier: "bold"
  };

  const valueLabelProps = {
    size: "small"
  };

  return (
    <div className={"oc-data-source-details"}>
      <Flex direction={"column"} gap={"12px"}>
        <Flex direction={"column"}>
          <Text {...fieldLabelProps}>{appstr("Data Source")}</Text>
          <Flex gap={"2px"} direction={"column"}>
            <Flex gap={"4px"} alignItems={"center"}>
              <Text {...valueLabelProps}>{sourceName}</Text>
              {sourceImage && (
                <img
                  className="responsiveImage"
                  src={sourceImage}
                  alt="fireSpot"
                  style={{ width: "20px", height: "20px" }}
                />
              )}
            </Flex>
            {sourceTip && (
              <Text size={"xsmall"} colorModifier={"lightgrey"}>
                {sourceTip}
              </Text>
            )}
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
};
